import React from "react";
import './LyricVideo.css';

import lyricvidborder from './../../../../images/lyricvidborder.png'
import lyricvid1 from './../../../../images/lyricvid1.png'
import lyricvid2 from './../../../../images/lyricvid2.png'
import lyricvid3 from './../../../../images/lyricvid3.png'
import lyricvid4 from './../../../../images/lyricvid4.png'
import lyricvid5 from './../../../../images/lyricvid5.png'
import lyricvid6 from './../../../../images/lyricvid6.png'
import lyricplayvid from './../../../../images/lyricplayvid.png'
import lyricviddots from './../../../../images/lyricviddots.png'
import lyricvidprice1 from './../../../../images/lyricvidprice1.png'
import lyricvidprice2 from './../../../../images/lyricvidprice2.png'
import lyricvidprice3 from './../../../../images/lyricvidprice3.png'
import lyricvidprice4 from './../../../../images/lyricvidprice4.png'
import lyricvidcusprice1 from './../../../../images/lyricvidcusprice1.png'
import lyricvidcusprice2 from './../../../../images/lyricvidcusprice2.png'
import lyricvidcusprice3 from './../../../../images/lyricvidcusprice3.png'
import Select from 'react-select'
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import roundbackbtn from './../../../../images/roundbackicon.png'
import { useState } from "react";
import {useLocation,useNavigate} from "react-router-dom";
import { Trans, useTranslation} from 'react-i18next'
import Cookies from 'universal-cookie';
import { useJwt, decodeToken } from "react-jwt";

function LyricVideo() {
    const [booknow,setBookNow] = useState(false)
    const {t, i18n } = useTranslation();
    const [name,setName] = useState("")
    const [email,setEmail] = useState("")
    const [projectName,setProjectName] = useState("")
    const [projectNotes,setProjectNotes] = useState("")
    const [quotecheckbox,setQuoteCheckBox] = useState(false)
    const [hearaboutus,setHearAboutUs] = useState("")
    const navigate = useNavigate();
    const cookies = new Cookies(null ,{ path: '/' });
    
    function topFunction() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    const hearAboutUsOptions = [{ value: 'Instagram', label: 'Instagram' },
    { value: 'Blogpost', label: 'Blogpost' },
    { value: 'Email', label: 'Email' }]

    const changehearAboutUsOptions = value => {
        setHearAboutUs(value)
    }

    const TrackcolourStyles = {
        control: styles => ({ ...styles,  borderColor: '#636468',
        backgroundColor:'rgba(0,0,0,16%)',
        width: '34.187em',
        height: '3em',
        borderRadius:'4px',
        color:'rgba(255, 255, 255, 1)',
        marginTop:'1.2em',
       
      }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
          return {
            ...styles,
            backgroundColor:'#18191F' ,
            color:'rgba(255, 255, 255, 1)',
            cursor: isDisabled ? 'not-allowed' : 'default',
            marginTop:'-0.3em',
            marginBottom:'-0.3em'
          };
        },
        input: (styles) => ( {...styles , 
                                FontFamily:'ClashGrotesk-Variable,sans-serif',
                                FontSize:'1rem',
                                FontWeight: 'medium',
                                LineHeight: '150%',
                                LetterSpacing: '0%',
                                color:'rgba(255, 255, 255, 1)'}),
        singleValue : (styles) => ({ ...styles, 
                                        color:'rgba(255, 255, 255, 1)',
                                        FontFamily:'ClashGrotesk-Variable,sans-serif',
                                        FontSize:'1rem',
                                        FontWeight: 'medium',
                                        LineHeight: '150%',
                                        LetterSpacing: '0%'})
      };


    return (
      <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
          

      <div style={{width:'100%'}}> 
   {
       !booknow &&
       <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
       <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',  backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/gg5vztrdvs4d4v06l3xg")`,width:'100%',height:'33.18em',marginTop:'-2.5em',backgroundSize:'cover'}}>
         <div style={{alignSelf:'flex-start',marginLeft:'2.5em',marginBottom:'1.125em',cursor:'pointer'}}>
           <img src={roundbackbtn} stlye={{width:'3.5em',height:'3.5em'}} onClick={()=>
            { if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                navigate("/Dashboard/promoteyourself")
              }

              if(decodeToken(cookies.get('token')).info.role==="label"){
                navigate("/dashboard/label/promoteartist")
              }}}/>
         </div>

         <div className="LyricBannerH1">
         <Trans i18nKey="Theno1lyricvideomakers" components={{1:<br/>}} >
         The No. 1  Lyric Video Makers<br/> On The Web
           </Trans>
          
         </div>

         <div className="LyricBannerH2"> 
         {t('Pricesbeginatonly')}
         </div>

         <div className="LyricBannerH3">
         {t('Fromindoemusiciestobignames')}
         </div>

         <div className="BookNowBtn" onClick={()=>setBookNow(true)}>
         {t('Booknow')} 
         <div className="PostLoginBtnOverlay"/>
         </div>
     </div>
       <div style={{
           backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/svwtqigjga4l2yj6clr2")`,
           width:'100%',
           height:'179.81em',
           backgroundSize:'cover',
           display:'flex',
           flexDirection:'column',
           paddingBottom:'33em',
           alignItems:'center'
       }}>
           {
               cookies.get('lang') === 'en' &&
               <div style={{display:'flex',flexDirection:'row',alignItems:'baseline',marginTop:'2.5em',marginBottom:'2.5em'}}>
             
                 <div className="LyricVidH1">
                     485M+
                 </div>
 
                 <div className="LyricVidH2">
                   Total YouTube views for our videos!
                 </div>
               </div>
             }

           {
               cookies.get('lang') === 'jp' &&
               <div style={{display:'flex',flexDirection:'row',alignItems:'baseline',marginTop:'2.5em',marginBottom:'2.5em'}}>
             
                 <div className="LyricVidH1">
                 YouTube 総再生回数は4 億 7,800 万回超え！
                 </div>
               </div>
             }
           

           <div style={{
           backgroundImage:`url(${lyricvidborder})`,
           backgroundSize:'cover',
           width:'70.7em',
           height:'41.475em',
           display:'flex',
           flexDirection:'column',
           alignItems:'center'
           }}>

               <div style={{display:'flex',flexDirection:'row',marginLeft:'2.5em',marginRight:'2.5em',marginTop:'2.5em',marginBottom:'3em'}}>
                   <div style={{display:'flex',flexDirection:'column',marginRight:'4.18em'}}>
                   <iframe
                       src={`https://www.youtube.com/embed/B-tOZxoNrFk?si=Iq1PeTj9E4nTRzTs`}
                       frameBorder="0"
                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                       allowFullScreen
                       title="Embedded youtube"
                       className="EmbeddedVideoList"
                       />
                       {/* <img src={lyricvid1} style={{width:'18.68em',height:'10.43em',marginBottom:'1em'}}/> */}
                       <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'space-between',alignItems:'center'}}>
                           <div style={{display:'flex',flexDirection:'column'}}>
                               <div className="VideoArtist">
                                   John Legend
                               </div>
                               <div className="VideoSong">
                                   You Deserve it All
                               </div>
                           </div>
                           <img src={lyricplayvid} style={{width:'3.125em',height:'3em'}}/>
                       </div>
                   </div>

                   <div style={{display:'flex',flexDirection:'column',marginRight:'4.18em'}}>
                   <iframe
                       src={`https://www.youtube.com/embed/5QIbxwNQR0s?si=5qnnZynhko2kkT8w`}
                       frameBorder="0"
                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                       allowFullScreen
                       title="Embedded youtube"
                       className="EmbeddedVideoList"
                       />
                       {/* <img src={lyricvid2} style={{width:'18.68em',height:'10.43em',marginBottom:'1em'}}/> */}
                       <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'space-between',alignItems:'center'}}>
                           <div style={{display:'flex',flexDirection:'column'}}>
                               <div className="VideoArtist">
                                   Fireboy DML x Ed Sheeran
                               </div>
                               <div className="VideoSong">
                                   PERU
                               </div>
                           </div>
                           <img src={lyricplayvid} style={{width:'3.125em',height:'3em'}}/>
                       </div>
                   </div>

                   <div style={{display:'flex',flexDirection:'column'}}>
           
                   <iframe
                       src={`https://www.youtube.com/embed/l82ScBL6CLA?si=DV3_5tEuNp-IiJH2`}
                       frameBorder="0"
                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                       allowFullScreen
                       title="Embedded youtube"
                       className="EmbeddedVideoList"
                       />
                       {/* <img src={lyricvid3} style={{width:'18.68em',height:'10.43em',marginBottom:'1em'}}/> */}
                       <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'space-between',alignItems:'center'}}>
                           <div style={{display:'flex',flexDirection:'column'}}>
                               <div className="VideoArtist">
                               Statik Selektah x Jack Harlow
                               </div>
                               <div className="VideoSong">
                               Mass Appeal
                               </div>
                           </div>
                           <img src={lyricplayvid} style={{width:'3.125em',height:'3em'}}/>
                       </div>
                   </div>
               </div>

               <div style={{display:'flex',flexDirection:'row',marginLeft:'2.5em',marginRight:'2.5em',marginTop:'1.5em',marginBottom:'3em'}}>
                   <div style={{display:'flex',flexDirection:'column',marginRight:'4.18em'}}>
                   <iframe
                       src={`https://www.youtube.com/embed/eiXULl40N3I?si=XvKju8-tGEv-3lz1`}
                       frameBorder="0"
                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                       allowFullScreen
                       title="Embedded youtube"
                       className="EmbeddedVideoList"
                       />
                       {/* <img src={lyricvid4} style={{width:'18.68em',height:'10.43em',marginBottom:'1em'}}/> */}
                       <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'space-between',alignItems:'center'}}>
                           <div style={{display:'flex',flexDirection:'column'}}>
                               <div className="VideoArtist">
                                   Young Bleu x Drake
                               </div>
                               <div className="VideoSong">
                                   You’re Mines Still
                               </div>
                           </div>
                           <img src={lyricplayvid} style={{width:'3.125em',height:'3em'}}/>
                       </div>
                   </div>

                   <div style={{display:'flex',flexDirection:'column',marginRight:'4.18em'}}>
                   <iframe
                       src={`https://www.youtube.com/embed/8kQH9MnCR0c?si=gRkEEhutr2kld1PK`}
                       frameBorder="0"
                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                       allowFullScreen
                       title="Embedded youtube"
                       className="EmbeddedVideoList"
                       />
                       {/* <img src={lyricvid5} style={{width:'18.68em',height:'10.43em',marginBottom:'1em'}}/> */}
                       <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'space-between',alignItems:'center'}}>
                           <div style={{display:'flex',flexDirection:'column'}}>
                               <div className="VideoArtist">
                               Jason Derulo x Adam Levine
                               </div>
                               <div className="VideoSong">
                               Lifestyle
                               </div>
                           </div>
                           <img src={lyricplayvid} style={{width:'3.125em',height:'3em'}}/>
                       </div>
                   </div>

                   <div style={{display:'flex',flexDirection:'column'}}>
                   <iframe
                       src={`https://www.youtube.com/embed/0VQ7uo4h4yM?si=W3KSnS3hfokcOILk`}
                       frameBorder="0"
                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                       allowFullScreen
                       title="Embedded youtube"
                       className="EmbeddedVideoList"
                       />
                       {/* <img src={lyricvid6} style={{width:'18.68em',height:'10.43em',marginBottom:'1em'}}/> */}
                       <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'space-between',alignItems:'center'}}>
                           <div style={{display:'flex',flexDirection:'column'}}>
                               <div className="VideoArtist">
                               Tiesto x Ty Dolla Sign
                               </div>
                               <div className="VideoSong">
                               The Business II
                               </div>
                           </div>
                           <img src={lyricplayvid} style={{width:'3.125em',height:'3em'}}/>
                       </div>
                   </div>
               </div>

               <div style={{display:'flex',flexDirection:'row',marginTop:'5.5em',alignItems:'center',height:'16.5em'}}>
                   <iframe
                       src={`https://www.youtube.com/embed/i3xny9Y4cLQ?si=xcMDKvDEg0jc9PIG`}
                       frameBorder="0"
                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                       allowFullScreen
                       title="Embedded youtube"
                       className="EmbeddedVideo"
                       />
                   <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'30.25em',marginLeft:'2.5em'}}>
                       <div className="LyricVideoTipsH1">
                       {t('fivetipstogetthemostoutofyourlyric')} 
                       </div>
                       <img src={lyricviddots} style={{width:'17.56em',height:'0.01em',alignSelf:'flex-start',marginBottom:'1.5em'}}/>
                       <div className="LyricVideoTipsH2">
                       {t('Ourserviceisthewebsleadingprovider')} 
                       </div>
                   </div>
               </div>

               <div style={{display:'flex',flexDirection:'row',marginTop:'5.5em',alignItems:'center',height:'16.5em'}}>
                  
                   <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'20em',marginRight:'10.5em'}}>
                       <div className="LyricVideoTipsH1">
                           
                           <Trans i18nKey="Videoproductionlevels" components={{1:<br/>}} >
                           Video Production<br/> Levels
                             </Trans>
                       </div>
                      
                       <div className="LyricVideoTipsH2">
                       {t('Wegroupourvideosintoproduction')} 
                       </div>
                   </div>

                   <iframe
                       src={`https://www.youtube.com/embed/_bBufOE3X74?si=LoaLeQ9HLDX2GAch`}
                       frameBorder="0"
                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                       allowFullScreen
                       title="Embedded youtube"
                       className="EmbeddedVideo"
                       />
               </div>

               <div style={{display:'flex',flexDirection:'row',width:'69.25em',marginTop:'4.5em'}}>
                   <div className="LyricVideoPlanBox">
                       <div style={{display:'flex',flexDirection:'column',marginLeft:'1.5em',marginRight:'1.5em'}}>
                       <div className="LyricVideoPlanTitle" style={{color:'#4CFFBE'}}>
                       {t('STANDARD')} 
                       </div>
                       
                         {
                           cookies.get('lang') === 'en' &&
                           <div style={{display:'flex',flexDirection:'row',alignItems:'flex-end'}}>
                              <div className="LyricVideoPlandollasign">
                               $
                           </div>
                           <div  className="LyricVideoPrice">
                           499
                           </div>
                         </div>
                         }

                       {
                           cookies.get('lang') === 'jp' &&
                           <div style={{display:'flex',flexDirection:'row',alignItems:'flex-end'}}>
                              <div className="LyricVideoPlandollasign">
                              ¥
                           </div>
                           <div  className="LyricVideoPrice">
                           75,000
                           </div>
                         </div>
                         }
                          

                       <div className="LyricVideoDesc">
                       {t('Simpleandcleanasinglebackground')} 
                       </div>
                      </div>

                      <img src={lyricvidprice1} style={{width:'12.43em',height:'7.5em',marginBottom:'1.5em'}}/>
                   </div>



                   <div className="LyricVideoPlanBox">
                       <div style={{display:'flex',flexDirection:'column',marginLeft:'1.5em',marginRight:'1.5em'}}>
                       <div className="LyricVideoPlanTitle" style={{color:'#AAD1FB'}}>
                       {t('Plus')} 
                       </div>

                       {
                           cookies.get('lang') === 'en' &&
                           <div style={{display:'flex',flexDirection:'row',alignItems:'flex-end'}}>
                           <div className="LyricVideoPlandollasign">
                               $
                           </div>
                           <div  className="LyricVideoPrice">
                               749
                           </div>
                       </div>
                         }

                       {
                           cookies.get('lang') === 'jp' &&
                           <div style={{display:'flex',flexDirection:'row',alignItems:'flex-end'}}>
                              <div className="LyricVideoPlandollasign">
                              ¥
                           </div>
                           <div  className="LyricVideoPrice">
                          100,000
                           </div>
                         </div>
                         }
                       

                       <div className="LyricVideoDesc">
                       {t('Somevariationsoftextstyle')} 
                       </div>
                      </div>

                      <img src={lyricvidprice2} style={{width:'12.43em',height:'7.5em',marginBottom:'1.5em'}}/>
                   </div>



                   <div className="LyricVideoPlanBox">
                       <div style={{display:'flex',flexDirection:'column',marginLeft:'1.5em',marginRight:'1.5em'}}>
                       <div className="LyricVideoPlanTitle" style={{color:'#ACACAC'}}>
                       {t('Platinum')} 
                       </div>
                       {
                           cookies.get('lang') === 'en' &&
                           <div style={{display:'flex',flexDirection:'row',alignItems:'flex-end'}}>
                           <div className="LyricVideoPlandollasign">
                               $
                           </div>
                           <div  className="LyricVideoPrice">
                               999
                           </div>
                         </div>
                         }

                       {
                           cookies.get('lang') === 'jp' &&
                           <div style={{display:'flex',flexDirection:'row',alignItems:'flex-end'}}>
                              <div className="LyricVideoPlandollasign">
                              ¥
                           </div>
                           <div  className="LyricVideoPrice">
                          150,000
                           </div>
                         </div>
                         }
                       

                       <div className="LyricVideoDesc">
                       {t('Morecomplexsequencesmultiple')} 
                       </div>
                      </div>

                      <img src={lyricvidprice3} style={{width:'12.43em',height:'7.5em',marginBottom:'1.5em'}}/>
                   </div>



                   <div className="LyricVideoPlanBox">
                       <div style={{display:'flex',flexDirection:'column',marginLeft:'1.5em',marginRight:'1.5em'}}>
                       <div className="LyricVideoPlanTitle" style={{color:'#F5C095'}}>
                       {t('Infinity')} 
                       </div>
                       {
                           cookies.get('lang') === 'en' &&
                           <div style={{display:'flex',flexDirection:'row',alignItems:'flex-end'}}>
                           <div className="LyricVideoPlandollasign">
                               $
                           </div>
                           <div  className="LyricVideoPrice">
                               1499
                           </div>
                       </div>
                         }

                       {
                           cookies.get('lang') === 'jp' &&
                           <div style={{display:'flex',flexDirection:'row',alignItems:'flex-end'}}>
                              <div className="LyricVideoPlandollasign">
                              ¥
                           </div>
                           <div  className="LyricVideoPrice">
                         220,000
                           </div>
                         </div>
                         }
                      

                       <div className="LyricVideoDesc">
                       {t('Dynamicandcustomizedwithour')}
                       </div>
                      </div>

                      <img src={lyricvidprice4} style={{width:'12.43em',height:'7.5em',marginBottom:'1.5em'}}/>
                   </div>
               </div>

               <div style={{display:'flex',flexDirection:'row',marginTop:'2em',alignItems:'center',marginBottom:'2em'}}>
                   <div style={{width:'24.62em',height:'0.1em',backgroundColor:'rgba(255,255,255,40%)'}}/>

                   <div className="OR">
                   {t('Or')}
                   </div>
                   
                   <div style={{width:'24.62em',height:'0.1em',backgroundColor:'rgba(255,255,255,40%)'}}/>
               </div>

               <div className="CustomPriceBox">
                       <div style={{display:'flex',flexDirection:'column',marginRight:'1.5em'}}>
                           <div className="CustomPriceBoxH1"> 
                           {t('Consultation')}
                           </div>

                           <div className="CustomPriceBoxH2">
                           {t('Customprice')} 
                           </div>

                           <div className="CustomPriceBoxH3">
                           {t('Bespokelyricvideos')} 
                           </div>
                       </div>

                       <div style={{display:'flex',flexDirection:'row'}}>
                           <iframe
                           src={`https://www.youtube.com/embed/kFfqd56blsU?si=fY88GzuqF5bLJcaH`}
                           frameBorder="0"
                           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                           allowFullScreen
                           title="Embedded youtube"
                           className="EmbeddedVideoSmall"
                           />

                           <iframe
                           src={`https://www.youtube.com/embed/ieQZXpu63RY?si=wPFuI7Z-O9vGXq8F`}
                           frameBorder="0"
                           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                           allowFullScreen
                           title="Embedded youtube"
                           className="EmbeddedVideoSmall"
                           />

                           <iframe
                           src={`https://www.youtube.com/embed/27JXW4WLn9k?si=WDw4a3cvtC3gDYpy`}
                           frameBorder="0"
                           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                           allowFullScreen
                           title="Embedded youtube"
                           className="EmbeddedVideoSmall"
                           />
                       </div>
               </div>

               <div className="HowToBookBox">
                   <div className="HowToBookBoxH1">
                       How to book your video
                   </div>

                   <div style={{display:'flex',flexDirection:'row'}}>
                       <div style={{display:'flex',flexDirection:'column',alignItems:'center',marginRight:'2.5em'}}>
                           <div className="HowToBookBoxH2">
                               1
                           </div>
                           <div className="HowToBookBoxH3">
                           {t('Submityoursong')}
                           </div>
                       </div>

                       <div style={{display:'flex',flexDirection:'column',alignItems:'center',marginRight:'2.5em'}}>
                           <div className="HowToBookBoxH2">
                               2
                           </div>
                           <div className="HowToBookBoxH3">
                           {t('Wewillreplyyoyouremail')}
                           </div>
                       </div>

                       <div style={{display:'flex',flexDirection:'column',alignItems:'center',marginRight:'2.5em'}}>
                           <div className="HowToBookBoxH2">
                               3
                           </div>

                           {
                           cookies.get('lang') === 'en' &&
                           <span className="HowToBookBoxH3">
                             
                           <span style={{textDecoration:'underline'}}>Payment by Paypal, credit card or bank wire.</span>At this point you can have as much creative control/input as you would like. Or our team of animators can come up with something based on the song.
                           </span>
                         }

                       {
                           cookies.get('lang') === 'jp' &&
                           <span className="HowToBookBoxH3">   
                             この時点で、あなたのアイデアを自由に反映させることも、曲に基づいて私たちが制作することもできます。
                           </span>
                         }
                           
                       </div>

                       <div style={{display:'flex',flexDirection:'column',alignItems:'center',marginRight:'2.5em'}}>
                           <div className="HowToBookBoxH2">
                               4
                           </div>
                           <div className="HowToBookBoxH3">
                           {t('Wedelivervideosin1to2weeks')}
                           </div>
                       </div>
                   </div>
               </div>

               <div className="BookNowBtn" onClick={()=>{setBookNow(true);topFunction()}}>
               {t('Booknow')} 
               <div className="PostLoginBtnOverlay"/>
               </div>

           </div>

           </div>
       </div>
   }

   {
       booknow &&
       <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}>
           <div style={{width:'100%'}}>
               <img src={roundbackbtn} style={{width:'3.5em',height:'3.5em',marginTop:'2.5em',marginLeft:'2.5em',cursor:'pointer'}} onClick={()=>setBookNow(false)}/>
           </div>

           <div className="BooknowFormH1">
              {t('Submityourproject')} 
           </div>

           <div className="BooknowFormH2">
             <Trans i18nKey="Fillouttheform" components={{1:<br/>}} >
             Fill out the form with your project details to help us understand your vision. 
             </Trans>
           </div>

           <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',alignSelf:'center'}}>
               <div className="BooknowInputHeader">
               {t('Name')}  
               </div>
               <input
               value={name}
               onChange={e =>{setName(e.target.value);}} 
               className='InputFieldbk'
               type='text'
               placeholder="Enter Name"
               // style={{marginLeft:'4.8em'}}
               />
           </div>

           <div style={{display:'flex',flexDirection:'column'}}>
               <div className="BooknowInputHeader">
               {t('Email')}   
               </div>
               <input
               value={email}
               onChange={e =>{setEmail(e.target.value);}} 
               className='InputFieldbk'
               type='text'
               placeholder="Enter Email"
               // style={{marginLeft:'4.8em'}}
               />
           </div>

           <div style={{display:'flex',flexDirection:'column'}}>
               <div className="BooknowInputHeader">
               {t('Projectname')}   
               </div>
               <input
               value={projectName}
               onChange={e =>{setProjectName(e.target.value);}} 
               className='InputFieldbk'
               type='text'
               placeholder="Enter Project Name"
               // style={{marginLeft:'4.8em'}}
               />
           </div>

           <div style={{display:'flex',flexDirection:'column'}}>
               <div className="BooknowInputHeader">
               {t('Projectnotes')}   
               </div>
               <textarea  rows="4" cols="50" className='InputFieldbktextarea' onChange={e =>{setProjectNotes(e.target.value);}}   placeholder="Enter Project Notes">
               {projectNotes}
               </textarea>
            
           </div>

           <div style={{display:'flex',flexDirection:'row',width: '37.187em',alignItems:'center'}}>
               <Checkbox checked={quotecheckbox} onChange={()=>setQuoteCheckBox(!quotecheckbox)}  
                           iconStyle={{fill: '#FFFFFF'}}
                           sx={{
                               [`&, &.${checkboxClasses.checked}`]: {
                                   color: '#FFFFFF',
                               },
                               color: "#E91353",
                               '&.Mui-checked': {
                               color: "#E91353"
                               }
                           }}
                           />
               <div className="SendSong">
                   {t('Sendingusasongforaquote?')}
               </div>
           </div>

           <div style={{display:'flex',flexDirection:'column',marginTop:'2em'}}>
               <div className="BooknowInputHeader">
               {t('Howdidyouhearaboutus?')}
               </div>
               <Select options={hearAboutUsOptions} value={hearaboutus} onChange={changehearAboutUsOptions} 
                   components={{
                       IndicatorSeparator: () => null
                   }}
                   placeholder="Select"
                   styles={
                       TrackcolourStyles
                   }
                   />
           </div>

           {
                           cookies.get('lang') === 'en' &&
                           <span className="BookNowTandC">
                           View our <span style={{color:'#4CFFBE'}}>order & refund policy</span>
                       </span>
                         }

                       {
                           cookies.get('lang') === 'jp' &&
                           <span className="BookNowTandC">
                           注文と返金ポリシーをご覧ください
                       </span>
                         }
          

           {
               (name.length===0 || email.length===0 || projectName.length===0 || projectNotes.length === 0 || hearaboutus.length!==undefined) &&
               <div className="SubmitBkNowBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto',marginBottom:'5em'}}>
                {t('Submit')}
           </div>
           }

       {
           name.length!==0 && email.length!==0 & projectName.length!==0 && projectNotes.length !== 0 && hearaboutus.length===undefined &&
               <div className="SubmitBkNowBtn"  style={{marginBottom:'5em'}} onClick={()=>{setName("");setEmail("");setProjectName("");setProjectNotes("");setQuoteCheckBox(false);setHearAboutUs("");
               if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                navigate("/Dashboard/promoteyourself")
              }

              if(decodeToken(cookies.get('token')).info.role==="label"){
                navigate("/dashboard/label/promoteartist")
              }}}>
                {t('Submit')}
                <div className="PostLoginBtnOverlay"/>
           </div>
           }
          



       </div>
   }
</div>
        
       </div>
      
    );
}

export default LyricVideo;